import { Component, EventEmitter, Input, OnInit, Output, ViewChild, AfterViewInit } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { MatAutocompleteTrigger, MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MenuService } from 'src/app/services/menu/menu.service';
import { SpinnerComponent } from "src/app/components/layout/spinner/spinner.component";

@Component({
  selector: 'app-parent-page-select',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatAutocompleteModule,
    MatFormFieldModule,
    MatInputModule,
    SpinnerComponent
],
  templateUrl: './parent-page-select.component.html',
  styleUrls: ['./parent-page-select.component.css'],
})
export class ParentPageSelectComponent implements OnInit, AfterViewInit {
  private _menuId: number = 1;
  @Input()
  set menuId(value: number) {
    this._menuId = value;
    this.loadMenuPages(); // reload menu pages whenever menuId changes
  }
  get menuId(): number {
    return this._menuId;
  }
  @Input() selectedPageId: number | null = null;
  @Output() selected = new EventEmitter<number>();

  @ViewChild(MatAutocompleteTrigger) autocompleteTrigger!: MatAutocompleteTrigger;

  searchControl = new FormControl('');
  allPages: any[] = [];
  filteredPages: any[] = [];


  load = false
  error = false

  constructor(private menuService: MenuService) {}

  ngOnInit() {
    this.listenToSearch();
    this.loadMenuPages();
  }

  loadMenuPages() {
    this.load = true
    this.menuService.getMenu().subscribe({
      next: (res: any) => {
        // console.log('menus: ', res);
        const rawPages = this.menuId == 1 ? res['top'] || [] : res['bottom'] || [];
        this.allPages = rawPages.flatMap((parent: any) => [parent, ...(parent.children || [])]);
        // console.log('all pages: ', this.allPages);
        this.filterPages(this.searchControl.value || '');
        if (this.selectedPageId !== null) {
          this.setSelectedPage(this.selectedPageId);
        }
        this.load = false
        this.error = false
      },
      error: (err) =>{ 
        // console.error('Error loading pages', err)
        this.load = false
        this.error = true
      },
    });
  }

  setSelectedPage(masterid: number) {
    const selectedPage = this.allPages.find(p => p.id === masterid);
    if (selectedPage) {
      this.searchControl.setValue(selectedPage);
    }
  }

 filterPages(query: any = '') {
  const safeQuery = String(query || '').toLowerCase();

  this.filteredPages = !safeQuery
    ? this.allPages
    : this.allPages.filter((p) =>
        (p?.menutitle || '').toLowerCase().includes(safeQuery)
      );
}

  listenToSearch() {
    this.searchControl.valueChanges.subscribe((value) => {
      console.log('searchControl value changed:', value);
      if (typeof value === 'string' || value === '') {
        this.filterPages(value);
        if (this.filteredPages.length && this.autocompleteTrigger) {
          this.autocompleteTrigger.openPanel();
        }
      } else {
        this.filterPages(this.searchControl.value || '');
      }
    });
  }

  ngAfterViewInit() {
    if (this.filteredPages.length && this.autocompleteTrigger) {
      this.autocompleteTrigger.openPanel();
    }
  }

  onSelect(value: any) {
    this.selected.emit(value?.id || 0);
  }

  displayFn = (page: any) => {
    return page?.menutitle || '';
  };

  onInputClick(): void {
    // console.log('input clicked, opening panel');
    if (this.autocompleteTrigger) {
      this.autocompleteTrigger.openPanel();
    }
  }
  
}